import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit, Close as IconClose } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";

import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { API_CONFIG, CONFIG, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DateFunctions } from "common/datefunctions";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { CUSTOMER_APIs } from "apihandlers/customer";
import AutoComplete from "components/Custom/AutoComplete";
import { GEO_APIs } from "apihandlers/geography";
import RadioBtn from "components/Custom/RadioBtn";
import TxtBox from "components/Custom/TxtBox";
import { AUTH_APIs } from "apihandlers/auth";
import SkeletonBox from "components/Custom/SkeletonBox";

const thumbnailImg = require("assets/images/pdf.png");

const FileUpload = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploading, setUploading] = useState<boolean>(false);

  const stateRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await CUSTOMER_APIs.getCustSalesTypes(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getCities:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "uploadType",
      name: LABELS.UPLOAD_TYPE,
      width: "20%",
      type: "date",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "UploadedFile",
      name: LABELS.UPLOADED_FILE,
      width: "70%",
      type: "date",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];
  const radioList = [
    {
      id: "leads",
      value: "leads",
      label: "Leads",
      //   checked: true,
      disabled: false,
    },
    {
      id: "priceList",
      value: "priceList",
      label: "Price List",
      disabled: false,
    },
    {
      id: "salesData",
      value: "salesData",
      label: "Sales Data",
      disabled: false,
    },
    {
      id: "SalesTeam",
      value: "SalesTeam",
      label: "Sales Team",
      disabled: false,
    },
    {
      id: "routes",
      value: "routes",
      label: "Routes",
      disabled: false,
    },
  ];
  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  //   const onchange=()=>{
  //     const value=
  //   }

  const manageFileUpload = () => {
    const fileUploadType = document.querySelector(
      'input[name="uploadType"]:checked'
    ) as HTMLInputElement;
    const status = fileUploadType ? fileUploadType.value : "";

    // Validations
    let errors = [];
    if (!fileUploadType) {
      errors.push({
        id: "uploadType",
        msg:
          "<span class='bold'>" +
          LABELS.FILE_UPLOAD_TYPE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      status,
      uploadedFiles,

      //activeStatus,
    };
    console.log("args", args);

    // setIsSubmit(true);

    setSelectedRow({});
    setManageDialog(false);
    reloadGrid();

    //TODO API still in progress
    //     CUSTOMER_APIs.manageCustSalesType(args).then((res) => {
    //       setIsSubmit(false);
    //       if (res.status === 200) {
    //         COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
    //         setSelectedRow({});
    //         setManageDialog(false);
    //         reloadGrid();
    //       } else {
    //         COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    //       }
    //     });
  };
  const onUploadFile = (e: any, f: any) => {
    console.log("onUploadFile: ", e, f);
    const file: any = e.target.files[0];
    // if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
    //   return;
    // }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      setUploading(true);
      uploadFile(file, base64).then((res) => {
        setUploading(false);
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "file",
    };
    let fileInfo = null;
    try {
      const res = await AUTH_APIs.fileUpload(args);
      console.log("uploadFile: ", args, res);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        setUploadedFiles([...uploadedFiles, fileInfo]);
        (document.getElementById("uploadFile") as HTMLInputElement).value =
          null;
      }
    } catch (error) {}
    return fileInfo;
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.FILE_UPLOAD}</li>
        </ul>
        <h4>{TITLES.FILE_UPLOAD}</h4>
        <p>{SUB_TITLES.FILE_UPLOAD}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.FILE_UPLOAD}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.FILE_UPLOAD + ": " + selectedRow.state
              : "Add New " + LABELS.FILE_UPLOAD
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup ">
            <label>File Upload Type</label>
            <RadioBtn list={radioList} row={true} name={"uploadType"} />
          </div>

          <label>{LABELS.CHOOSE_FILE}</label>
          <div>
            <TxtBox
              type={"file"}
              id="uploadFile"
              defaultValue={selectedRow.id ? selectedRow.files : null}
              // className="uploadFile"
              accept="image/*"
              onChange={onUploadFile}
            />
          </div>
          {uploadedFiles.map((u, i) => {
            return (
              <div className="thumbnailBox width20">
                <IconButton
                  className="thumbnailBoxIcon"
                  onClick={() => {
                    const lists = uploadedFiles.filter((a, j) => j !== i);
                    setUploadedFiles(lists);
                  }}
                >
                  <IconClose />
                </IconButton>
                <img
                  onClick={() =>
                    window.open(API_CONFIG.STATIC_URL + u.path, "_blank")
                  }
                  src={
                    u.mimeType === "pdf"
                      ? thumbnailImg
                      : API_CONFIG.STATIC_URL + u.path
                  }
                  className="responsive cursor"
                />
              </div>
            );
          })}

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div style={{ marginTop: "1rem" }}>
            <Btn
              text={LABELS.UPLOAD}
              //   loading={isSubmit}
              onClick={manageFileUpload}
              bgColor={COLORS.SAVE_GREEN}
            />
            {uploading && (
              <div className="thumbnailBox width20">
                <SkeletonBox height={300} />
              </div>
            )}
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(FileUpload);
